import { FeaturePost } from '../FeaturePosts';

export const insightsAndTrends: FeaturePost = {
  id: 'insights-and-trends',
  cardImage: `${process.env.PUBLIC_URL}/assets/features/insights.png`,
  image: '',
  tag: 'Insights',
  date: '2026-08-22',
  title: 'Insights & Trends',
  subtitle: 'See how your symptoms, food and mood connect over time',
  readTime: '3 min',
  content: `Logging is only half the story. Toastie looks across everything you track to help you spot connections you might miss on your own.

#### What you can see

- **Trends** in your symptoms over weeks and months
- **Connections** between what you eat and how you feel
- **Mood insights** alongside your other trackers
- A **year view heatmap** of your health at a glance

#### Built for real bodies

Every body is different, so Toastie's insights are based on *your* history, not averages.`,
};
